import React, {useEffect, useState} from 'react'
import {Button, Input, Modal, Select} from "antd"
import {createUser, getRoleList} from '../../../../services/api/UserService'

const {Option} = Select

function NewUserPopup(props) {
    const {isOpen, onClose, onReset, reloadUsers} = props
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [validateError, setValidateError] = useState({usernameError: '', passwordError: '', confirmError: ''})
    const [state, setState] = useState({username: '', password: '', re_password: ''})
    const [listRoles, setListRoles] = useState([])
    const [roles, setRoles] = useState([])

    const _handleChangeInput = (e) => {
        const {name, value} = e.target
        setValidateError({usernameError: '', passwordError: '', confirmError: ''})

        setState({
            ...state,
            [name]: value.trim()
        })
    }

    const _handleChangeRole = (value) => {
        setRoles(value)
    }

    const _userValidator = () => {
        if (state.username.trim() === '') {
            setValidateError({
                ...validateError,
                usernameError: 'Username is null or invalid!'
            })
            return false
        }
        if (state.password.trim() === '') {
            setValidateError({...validateError, passwordError: 'Password is null or invalid!'})
            return false
        }

        if (state.password.trim() !== state.re_password.trim()) {
            setValidateError({...validateError, confirmError: 'Password does not match!'})
            return false
        }
        if (state.password.trim().length <= 7) {
            setValidateError({...validateError, passwordError: 'Password must be at least 8 characters!'})
            return false
        }

        return true
    }

    const _createUser = (e) => {
        e.preventDefault()

        const isValid = _userValidator()

        if (!isValid) return

        _reqAddNew()
    }

    const _reqAddNew = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                username: state.username,
                password: state.password,
                roles: roles
            }
            const {success, message} = await createUser(payload)

            if (!success) {

                setLoading(false)
                return setError(message)
            }

            setLoading(false)
            onClose()
            await onReset()
            reloadUsers()
        } catch (e) {
            setLoading(false)
            if (e.response.status !== 200) {
                setError(e.response.data.message)
            } else {
                setError(e.message)
            }
        }
    }

    const _closeModal = () => {
        setError('')
        setState({username: '', password: '', re_password: ''})
        setValidateError({usernameError: '', passwordError: '', confirmError: ''})
        setLoading(false)
        onClose()
    }

    const getUserRoles = async () => {
        try {
            const {success, data, message} = await getRoleList()

            if (!success) return setError(message)

            const {roles} = data

            setListRoles(roles)
        } catch (e) {
            setError(e.message)
        }
    }

    useEffect(() => {
        getUserRoles()
    }, [])

    return (
        <Modal
            title="Create user"
            visible={isOpen}
            onOk={_createUser}
            onCancel={_closeModal}
            footer={[
                <Button key="back" onClick={_closeModal}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={_createUser}>
                    Create
                </Button>
            ]}
        >
            <div className="mb-3">
                <label>Username</label>
                <Input name="username" value={state.username || ''} onChange={_handleChangeInput}/>
                {validateError.usernameError && <div className="mt-1 text-danger">{validateError.usernameError}</div>}
            </div>
            <div className="mb-3">
                <label>Password</label>
                <Input type="password" name="password" value={state.password || ''} onChange={_handleChangeInput}/>
                {validateError.passwordError && <div className="mt-1 text-danger">{validateError.passwordError}</div>}
            </div>
            <div className="mb-3">
                <label>Confirm password</label>
                <Input type="password" name="re_password" value={state.re_password || ''}
                       onChange={_handleChangeInput}/>
                {validateError.confirmError && <div className="mt-1 text-danger">{validateError.confirmError}</div>}
            </div>
            <div className="mb-3">
                <label className="mr-3">Roles</label>
                <Select
                    mode="multiple"
                    placeholder="Please select"
                    value={roles || []}
                    onChange={_handleChangeRole}
                    style={{width: '100%'}}
                >
                    {
                        !!listRoles && listRoles.length > 0 && listRoles.map(item => (
                            <Option key={item._id} value={item._id}>{item.name}</Option>
                        ))
                    }
                </Select>
            </div>
            {error && <div className="mt-3 text-danger">{error}</div>}
        </Modal>
    )
}

export default NewUserPopup
